import styled, { css } from "styled-components";
import Icon from "../Common/Icon";

interface CloseIconProps {
  $variant?: "default" | "modal";
}

export const CloseIcon = styled(Icon)<CloseIconProps>`
  position: absolute;
  cursor: pointer;
  right: 2rem;

  ${({ $variant }) =>
    $variant === "modal"
      ? css`
          top: 14.5rem;
          right: 4rem;
          z-index: 100;

          @media ${({ theme }) => theme.device.tablet} {
            top: 13.5rem;
          }
        `
      : css`
          top: 2rem;

          @media ${({ theme }) => theme.device.tablet} {
            top: 3.5rem;
          }
        `}
`;
